import { useTranslation } from 'react-i18next'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type PackagingSupplierOnboardingStatusProps = {
  magicLinkFirstOpenedAt?: string | null
  ppwrComplianceAcknowledgedAt?: string | null
}

function formatOnboardingDate(value: string, language: string): string {
  const locale = language.startsWith('zh') ? 'zh-CN' : 'en-GB'
  return new Date(value).toLocaleString(locale)
}

export function PackagingSupplierOnboardingStatus({
  magicLinkFirstOpenedAt,
  ppwrComplianceAcknowledgedAt,
}: PackagingSupplierOnboardingStatusProps) {
  const { t, i18n } = useTranslation('packagingSuppliers')

  if (!ppwrComplianceAcknowledgedAt && !magicLinkFirstOpenedAt) {
    return <span>{t('tracking.pending')}</span>
  }

  let label = ''
  let tooltipDate = ''
  if (ppwrComplianceAcknowledgedAt) {
    label = t('details.onboarding.finishedOnboarding')
    tooltipDate = formatOnboardingDate(
      ppwrComplianceAcknowledgedAt,
      i18n.language
    )
  } else if (magicLinkFirstOpenedAt) {
    label = t('details.onboarding.accessedSupplierPortal')
    tooltipDate = formatOnboardingDate(magicLinkFirstOpenedAt, i18n.language)
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className='cursor-default'>{label}</span>
      </TooltipTrigger>
      <TooltipContent side='top'>{tooltipDate}</TooltipContent>
    </Tooltip>
  )
}
